import { Renderer } from '@angular/core';
import { Component } from '@angular/core';
import { IonicPage, NavParams } from 'ionic-angular';
import { NavController, ModalController, AlertController } from 'ionic-angular';
import * as moment from 'moment';

import { VariablesProvider } from '../../providers/variables/variables';
import { FuncionesProvider } from '../../providers/funciones/funciones';
import { PicajesPage } from '../../pages/picajes/picajes';
import { VerlistaPage } from '../../pages/verlista/verlista';
import { ViewController } from 'ionic-angular';
import { CalendarioPage } from '../../pages/calendario/calendario';
import { LoginPage } from '../../pages/login/login';
import { CalendarModal, CalendarModalOptions, DayConfig, CalendarResult } from "ion2-calendar";
import { CalendarComponentOptions } from 'ion2-calendar'
import { FormBuilder, FormGroup, Validators} from '@angular/forms';

@IonicPage()
@Component({
  selector: 'page-objetos',
  templateUrl: 'objetos.html',
})


export class ObjetosPage {

  myParam = '';

 diasdefiesta;
  myForm: FormGroup;
  myForm1: FormGroup;
  myForm2: FormGroup;

  misapp: Array<{title: string, descripcion: string, imagen: string , component: any}>;
  formulario = {codigo1: "",nombre1: "",activo1: ""}
  resultado;
  date: string;
  type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  minuto = []; //= {valor: "1",color: "1"}
  color = []; //= {valor: "1",color: "1"}
  cabecera = []; //= {valor: "1",color: "1"}
  empresas;
  valo="654321123456" ;
  formulario2 = {valor: ""}
  empresasKeys;
  values:Array<string> = [];
  grupos;
 
  constructor(
  	public navParams: NavParams,
    public fb: FormBuilder,
    private alertCtrl: AlertController,
    public modalCtrl: ModalController,
  	public navCtrl: NavController,
    public funciones:FuncionesProvider,
  	public variables:VariablesProvider
    ) {                    
            
      this.variables.btatras = true;
      var sum = 0;
      var horas=0;

 
      this.myForm = this.fb.group({id: [''], nombre: ['' ], activo: ['' ] });
      this.myForm1 = this.fb.group({id1: ['', [Validators.required]], nombre1: ['', [Validators.required]], activo1: ['', [Validators.required]] });
   
      this.formulario.activo1 = "sala";

      this.obtenerobjetos(this.valo);

  }


  openModalWithParams(valor) {

            this.myParam ="Lista de grupos";
            let myModal = this.modalCtrl.create(VerlistaPage, {
              'id': valor, 
              'tabla': "objetoslin",
              'caption': this.myParam
            }
            );

            myModal.onDidDismiss(data => { 
              this.obtenerobjetos(this.valo);
            }); 
            myModal.present();

  }

  buscarobjetos(){
     var neutro;
    if (this.formulario2.valor != ""){
      neutro = this.formulario2.valor;
     }else{
      neutro = this.valo;
    }
    console.log("Vamos a buscar :" + neutro);
    this.funciones.obtieneobjetos().then(
          data => {

          this.empresas = data;
   

          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
  }

  obtenerobjetos(filtro){

    this.funciones.obtieneobjetos().then(
          data => {
            
            this.empresas = data;
           
          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
  }

   editarempresas(index){

     //console.log(this.empresas[index].ID);
     //console.log(this.empresas[index].NOMBRE);
    

    this.funciones.editarobjetos(this.empresas[index].ID,this.empresas[index].NOMBRE).then(
          data => {
            //console.log(data);
            this.empresas = data;
            this.obtenerobjetos(this.valo);
          }
      )
      .catch(
        error => {
          console.log(error);
        }
      )
     
  }

  registro(){

   //console.log(this.formulario.nombre1);

   this.funciones.grabarobjetos(this.formulario.nombre1,this.formulario.activo1).then(
     data => {
          this.resultado = data;

          this.obtenerobjetos(this.valo);

           this.formulario.nombre1="";

        })


  }

   borrar(codigo,nombre){

      let alert = this.alertCtrl.create({
          title: 'Borrar.',
          message: '¿Confirma borrar del objeto? '  + nombre,
          cssClass: 'alertCustomCss',
          buttons: [{
              text: 'No',
              role: 'No',
              handler: () => {  }
            },{
              text: 'Si',
              handler: () => {

               this.funciones.delobjetos(codigo).then(
                   data => {
                    
                    this.obtenerobjetos(this.valo);

                  })           
              }
            }
          ]
        });
        alert.present();
     
  }


ponencampo(campo:string, value:string):void{
      
      switch (campo) {
         case "ACTIVO":
           this.formulario.activo1 = value;
           break;
         
         default:
           // code...
           break;
       }
     
    }
 
 valChange(campo:string, value:string, index:number):void{
      
      switch (campo) {
         case "ID":
           this.empresas[index].ID = value;
           break;
         case "NOMBRE":
           this.empresas[index].NOMBRE = value;
           break;
          case "ACTIVO":
           this.empresas[index].ACTIVO = value;
           break;
         default:
           // code...
           break;
       }
     
    }



}




// WEBPACK FOOTER //
// ./src/pages/objetos/objetos.ts